import { isNumber } from 'OK/URLUtils';

export class URLData {
    // eslint-disable-next-line no-template-curly-in-string
    public static readonly _PATH_ANY: string = '$$${_PATH_ANY}';
    // eslint-disable-next-line no-template-curly-in-string
    public static readonly _PATH_DIGITS: string = '$$${_PATH_DIGITS}';

    private url: string;
    private protocol: string;
    private host: string;
    private path: string;
    private query: string;
    private parts: string[];
    private params: Map<string, string>;

    constructor(url: string, protocol: string, host: string, path: string, query: string, parts: string[], params: Map<string, string>) {
        this.url = url;
        this.protocol = protocol;
        this.path = path;
        this.host = host;
        this.query = query;
        this.parts = parts;
        this.params = params;
    }

    public getUrl(): string {
        return this.url;
    }

    public getProtocol(): string {
        return this.protocol;
    }

    public getHost():string {
        return this.host;
    }

    public getProtocolAndHost(): string {
        return !this.protocol ? this.host : `${this.protocol}${this.host}`;
    }

    public getPathAndQuery(): string {
        return !this.query ? this.path : `${this.path}?${this.query}`;
    }

    public getPath(): string {
        return this.path;
    }

    public getQuery(): string {
        return this.query;
    }

    public getParts(): string[] {
        return this.parts;
    }

    public getPartLen(): number {
        return this.parts?.length || 0;
    }

    public getPart(index: number): string | null {
        return (this.parts && index >= 0 && index < this.parts.length) ? this.parts[index] : null;
    }

    public contains(substr: string): boolean {
        return (this.url && substr && this.url.toLowerCase().includes(substr.toLowerCase())) as boolean;
    }

    public getParams(): Map<string, string> {
        return this.params;
    }

    public getParam(key: string): string {
        return this.params?.get(key.toLowerCase())!;
    }

    public hasParam(key: string): boolean {
        return !!this.getParam(key);
    }

    public checkPath(...pathRule: string[]): boolean {
        return pathRule.length === this.getPartLen() && this.checkPathStartsWith(...pathRule);
    }

    public checkPathStartsWith(...pathRule: string[]): boolean {
        if (this.getPartLen() < pathRule.length) {
            return false;
        }

        for (let i = 0; i < pathRule.length; i++) {
            if (pathRule[i] === URLData._PATH_ANY) {
                continue;
            }

            const p: string = this.getPart(i)!;
            if (pathRule[i] === URLData._PATH_DIGITS) {
                if (isNumber(p)) {
                    continue;
                } else {
                    return false;
                }
            }
            if (!(pathRule[i] === p)) {
                return false;
            }
        }

        return true;
    }
}
